<template>
  <highcharts v-if="!loading" :options="options"></highcharts>
  <v-progress-circular
    v-else
    :value="20"
    indeterminate
    color="#704DFA"
  ></v-progress-circular>
</template>

<script>
import FormatterHelper from "@/scripts/helpers/formatter.helper";
export default {
  props: {
    series: {
      type: Array,
      required: true
    },
    labels: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    }
  },
  name: "LineChart",
  data: () => ({
    options: {
      credits: {
        enabled: false
      },
      title: {
        text: null
      },
      xAxis: {
        type: "datetime",
        dateTimeLabelFormats: {
          day: "%d/%m/%y"
        }
      },
      yAxis: [
        {
          // Primary yAxis
          labels: {
            format: "{value}"
          },
          title: {
            text: "" //Quantidade de doações
          }
        },
        {
          // Secondary yAxis
          title: {
            text: "" //Valor total doado
          },
          labels: {
            formatter: function() {
              return FormatterHelper.formatMoney(this.value);
            }
          },
          opposite: true
        }
      ],
      tooltip: {
        formatter: function() {
          if (this.series.name == "Valor")
            return (
              '<b>Valor total doado</b><br><br/><span style="color:' +
              this.point.color +
              '">\u25CF</span>' +
              FormatterHelper.formatMoney(this.point.y)
            );
          else
            return (
              '<b>Quantidade de doações</b><br><span style="color:' +
              this.point.color +
              '">\u25CF</span>' +
              this.point.y
            );
        }
      },
      chart: {
        type: "areaspline"
      }
    }
  }),
  watch: {
    series: {
      handler: function() {
        if (this.options && this.series) {
          let series = [];
          let colors = ["#704DFA", "#5DCEF2"];
          for (let i = 0; i < this.series.length; i++) {
            let newSerie = {};
            newSerie.yAxis = i;
            newSerie.color = colors[i % colors.length];
            newSerie.name = this.labels[i];
            newSerie.data = this.series[i].map(point => {
              let date = FormatterHelper.parseDate(
                point.identifier,
                "yyyy-MM-dd"
              );
              return [
                Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()),
                point.value
              ];
            });
            series.push(newSerie);
          }
          this.$set(this.options, "series", series);
        }
      },
      deep: true
    }
  }
};
</script>